import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";

const intFormat = new Intl.NumberFormat("en-IN");
const qtlFormat = new Intl.NumberFormat("en-IN", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});
const Months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];
const getMonthName = (m) => Months[m - 1];
const OnrcAllotedSubDistDepot = ({
  month,
  year,
  comm_id,
  dist_code,
  depot_id,
  heading,
  commname,
  dist,
  depot,
  reportType,
  scheme
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [schemeNames, setSchemeNames] = useState([]);

  /* ---------- FETCH ---------- */
  useEffect(() => {
    setLoading(true);

    fetch(`${process.env.REACT_APP_URL_SALE}/reports/fps-wise`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        month,
        year,
        comm_id,
        scheme_id: scheme === "0" ? null : scheme,
        dist_code,
        depot_id,
        report_type: reportType
      })
    })
      .then(res => res.json())
      .then(json => {
        if (json?.rep_code === "200" && Array.isArray(json.data)) {
          setData(json.data);

          if (json.data[0]?.schemelist) {
            const names = Object.keys(json.data[0].schemelist)
              .filter(k => k.endsWith("_cards"))
              .map(k => k.replace("_cards", ""));
            setSchemeNames(names);
          }
        } else {
          setData([]);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [month, year, comm_id, scheme, dist_code, depot_id]);

  /* ---------- TOTALS ---------- */
  const totals = schemeNames.reduce((acc, s) => {
    data.forEach(r => {
      acc[`cards_${s}`] = (acc[`cards_${s}`] || 0) + (r.schemelist?.[`${s}_cards`] || 0);
     // acc[`trans_${s}`] = (acc[`trans_${s}`] || 0) + (r.schemelist?.[`${s}_trans`] || 0);
      acc[`qty_${s}`] = (acc[`qty_${s}`] || 0) + (r.schemelist?.[`${s}_qty`] || 0);
    });
    return acc;
  }, {});
  const columnTotal = (metric, scheme) =>
    data.reduce(
      (sum, r) => sum + (r.schemelist?.[`${scheme}_${metric}`] || 0),
      0
    );

  const metricGrandTotal = (metric) =>
    schemeNames.reduce(
      (sum, s) => sum + columnTotal(metric, s),
      0
    );

  /* ---------- EXCEL ---------- */
  // const exportExcel = () => {
  //   const aoa = [
  //     [`FPS Wise Allotment - ${depot} (${month}/${year})-${commname}`],
  //     [
  //       "Sl.No",
  //       "FPS Id",
  //       "FPS Name",
  //       ...["CARDS",  "QTY"].flatMap(h =>
  //         [...schemeNames, "Total"].map(s => `${h}-${s}`)
  //       )
  //     ]
  //   ];

  //   data.forEach((r, i) => {
  //     const row = [i + 1, r.sale_fps_id, r.fps_name];

  //     ["cards",  "qty"].forEach(f => {
  //       const vals = schemeNames.map(s => r.schemelist?.[`${s}_${f}`] || 0);
  //       const total = vals.reduce((a, b) => a + b, 0);

  //       row.push(
  //         ...vals,
  //         total
  //       );
  //     });

  //     aoa.push(row);
  //   });
  //   //  GRAND TOTAL ROW
  //   const totalRow = ["", "Total"];

  //   ["cards", "qty"].forEach(f => {
  //     // scheme column totals
  //     schemeNames.forEach(s => {
  //       totalRow.push(columnTotal(f, s));
  //     });

  //     // grand total per metric
  //     totalRow.push(metricGrandTotal(f));
  //   });

  //   aoa.push(totalRow);

  //   const ws = XLSX.utils.aoa_to_sheet(aoa);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "FPS");
  //   XLSX.writeFile(wb, `FPS_Allotment_${depot}_${month}_${year}.xlsx`);
  // };

   const exportExcel = () => {
      const table = document.getElementById("fpsdepotTable");
    
      const wb = XLSX.utils.table_to_book(table, { sheet: "District" });
    
      XLSX.writeFile(
        wb,
        `District_Allotment_${getMonthName(month)}_${year}.xlsx`
      );
    };

  if (loading) return <div align="center"><b>Loading...</b></div>;
  if (!data.length) return <div align="center">No data found</div>;

  return (
    <div style={{ overflowX: "auto" }}>
      <table id ="fpsdepotTable" width="100%" border="1" cellPadding="5">
        <thead>
          <tr className="tableheader">
            <th colSpan={3 + (schemeNames.length + 1) * 3}>
              {heading || `FPS Wise - ${depot}`}
            </th>
          </tr>

          {/* LEVEL 1 */}
          <tr className="tableheader">
            <th rowSpan={2}>Sl.No</th>
            <th rowSpan={2}>FPS Id</th>
            <th rowSpan={2}>FPS Name</th>
            {["CARDS",  "QTY"].map(h => (
              <th key={h} colSpan={schemeNames.length + 1}>{h}</th>
            ))}
          </tr>

          {/* LEVEL 2 */}
          <tr className="tableheader">
            {["CARDS",  "QTY"].flatMap(() =>
              [...schemeNames, "Total"].map(s => (
                <th key={s}>{s}</th>
              ))
            )}
          </tr>
        </thead>

        <tbody>
          {data.map((row, i) => (
            <tr key={row.sale_fps_id}>
              <td>{i + 1}</td>
              <td>{row.sale_fps_id}</td>
              <td>{row.fps_name}</td>

              {["cards",  "qty"].flatMap(f => {
                const values = schemeNames.map(
                  s => row.schemelist?.[`${s}_${f}`] || 0
                );
                const total = values.reduce((a, b) => a + b, 0);

                return [
                  ...values.map((v, idx) => (
                    <td key={`${f}-${idx}`} align="right">
                      {f === "qty"
                        ? qtlFormat.format(v)
                        : intFormat.format(v)}
                    </td>
                  )),
                  <td key={`${f}-t`} align="right">
                    {f === "qty"
                      ? qtlFormat.format(total)
                      : intFormat.format(total)}
                  </td>
                ];
              })}
            </tr>
          ))}

          {/* TOTAL ROW */}
          <tr className="tableheader">
            <td colSpan={3} align="right"><b>Total</b></td>

            {["cards","qty"].flatMap(f => {
              const values = schemeNames.map(
                s => totals[`${f}_${s}`] || 0
              );
              const total = values.reduce((a, b) => a + b, 0);

              return [
                ...values.map((v, i) => (
                  <td key={`${f}-t-${i}`} align="right">
                    <b>{f === "qty" ? qtlFormat.format(v) : intFormat.format(v)}</b>
                  </td>
                )),
                <td key={`${f}-tt`} align="right">
                  <b>{f === "qty" ? qtlFormat.format(total) : intFormat.format(total)}</b>
                </td>
              ];
            })}
          </tr>
        </tbody>
      </table>

      <br />
      <div align="center">
        <button className="button button2" onClick={exportExcel}>
          Download Excel
        </button>
      </div>
      <br /><br /><br />
    </div>

  );
};

export default OnrcAllotedSubDistDepot;
